/**
 * Open a URL in the platform's default browser.
 *
 * Plain web / PWA / Android webview: `window.open` works fine.
 * Tauri Windows wrapper: `window.open` silently no-ops because the
 * embedded webview has no host to open a new tab with — the request
 * never reaches the OS shell. Route through tauri-plugin-opener,
 * which is already wired up in src-tauri/Cargo.toml + Rust main and
 * granted via the `opener:default` capability, so the OS default
 * browser launches the URL.
 *
 * We feature-detect the Tauri global instead of taking an npm
 * dependency so the same bundle keeps working in every build target.
 */
export function openExternalUrl(url) {
  if (!url || typeof window === 'undefined') return;

  try {
    const tauri = window.__TAURI__;
    const invoke =
      tauri && tauri.core && typeof tauri.core.invoke === 'function'
        ? tauri.core.invoke
        : null;
    if (invoke) {
      invoke('plugin:opener|open_url', { url }).catch(() => {
        // If the plugin call fails (unlikely with opener:default
        // granted), fall back to window.open rather than leaving the
        // user staring at a dead button.
        try { window.open(url, '_blank', 'noopener'); } catch (_) {}
      });
      return;
    }
  } catch (_) {
    /* fall through */
  }

  try {
    window.open(url, '_blank', 'noopener');
  } catch (_) {
    /* noop */
  }
}
